const EMBED_STORAGE_KEY = 'ots_embed';
const EMBED_SOURCE_KEY = 'ots_embed_source';
const SSO_ERROR_KEY = 'ots_sso_error';

export type EmbedHostSource = 'ERP' | 'GARAGES' | 'FLOWW';

const CHANNEL_CODE_BY_SOURCE: Record<EmbedHostSource, string> = {
  ERP: 'ERP',
  GARAGES: 'GARAGES',
  FLOWW: 'FLOWWW',
};

function normalizeHostSource(raw: string): EmbedHostSource | null {
  const value = raw.trim().toUpperCase();
  if (value === 'ERP' || value === 'GARAGES' || value === 'FLOWW') return value;
  if (value === 'FLOWWW') return 'FLOWW';
  return null;
}

export function captureEmbedFlag(search: string): void {
  const params = new URLSearchParams(search);
  if (params.get('embed') === '1') {
    sessionStorage.setItem(EMBED_STORAGE_KEY, '1');
  }
  const fromQuery = normalizeHostSource(params.get('source') ?? '');
  if (fromQuery) {
    sessionStorage.setItem(EMBED_SOURCE_KEY, fromQuery);
  } else if (params.get('embed') === '1' && !sessionStorage.getItem(EMBED_SOURCE_KEY)) {
    sessionStorage.setItem(EMBED_SOURCE_KEY, 'ERP');
  }
}

export function isOtsEmbed(): boolean {
  return sessionStorage.getItem(EMBED_STORAGE_KEY) === '1';
}

export function getEmbedSource(): EmbedHostSource | null {
  if (!isOtsEmbed()) return null;
  return normalizeHostSource(sessionStorage.getItem(EMBED_SOURCE_KEY) ?? '') ?? 'ERP';
}

export function getEmbedChannelCode(): string | null {
  const source = getEmbedSource();
  return source ? CHANNEL_CODE_BY_SOURCE[source] : null;
}

export function stripSsoParamsFromUrl(): void {
  const url = new URL(window.location.href);
  url.searchParams.delete('sso');
  url.searchParams.delete('source');
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, '', next);
}

export function setSsoError(): void {
  sessionStorage.setItem(SSO_ERROR_KEY, '1');
}

export function consumeSsoError(): boolean {
  const had = sessionStorage.getItem(SSO_ERROR_KEY) === '1';
  if (had) sessionStorage.removeItem(SSO_ERROR_KEY);
  return had;
}
